

import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "@/lib/utils"

function TooltipProvider({
  delayDuration = 0,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Provider>) {
  return (
    <TooltipPrimitive.Provider
      data-slot="tooltip-provider"
      delayDuration={delayDuration}
      {...props}
    />
  )
}

function Tooltip({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Root>) {
  return (
    <TooltipProvider>
      <TooltipPrimitive.Root data-slot="tooltip" {...props} />
    </TooltipProvider>
  )
}

function TooltipTrigger({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Trigger>) {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />
}

function TooltipContent({
  className,
  sideOffset = 0,
  children,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          "vtwo:bg-primary vtwo:text-primary-foreground vtwo:animate-in vtwo:fade-in-0 vtwo:zoom-in-95 vtwo:data-[state=closed]:animate-out vtwo:data-[state=closed]:fade-out-0 vtwo:data-[state=closed]:zoom-out-95 vtwo:data-[side=bottom]:slide-in-from-top-2 vtwo:data-[side=left]:slide-in-from-right-2 vtwo:data-[side=right]:slide-in-from-left-2 vtwo:data-[side=top]:slide-in-from-bottom-2 vtwo:z-50 vtwo:w-fit vtwo:origin-(--radix-tooltip-content-transform-origin) vtwo:rounded-md vtwo:px-3 vtwo:py-1.5 vtwo:text-xs vtwo:text-balance",
          className
        )}
        {...props}
      >
        {children}
        <TooltipPrimitive.Arrow className="vtwo:bg-primary vtwo:fill-primary vtwo:z-50 vtwo:size-2.5 vtwo:translate-y-[calc(-50%_-_2px)] vtwo:rotate-45 vtwo:rounded-[2px]" />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  )
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
